import React from 'react'
import { IntlProvider } from 'react-intl'
import { getTranslationsForLang as getWebsiteComponentsTranslationsForLang } from '@grammarly/website-components'
import { useLanguage } from '@lib/hooks'
import esCmsTranslations from '@lib/i18n/locales/compiled/es.json'
import { DEFAULT_LANG } from '@lib/constants'
import { Lang } from '@lib/utils/locale'

const getCmsTranslationsForLang = (lang: Lang) => {
  switch (lang) {
    case 'es':
      return esCmsTranslations
    case 'en':
    default:
      return {} // Use english fallback
  }
}
interface CmsI18nProviderProps {
  children: React.ReactNode
}

export const CmsI18nProvider: React.FC<CmsI18nProviderProps> = ({ children }) => {
  const { lang } = useLanguage()

  const cmsTranslations = getCmsTranslationsForLang(lang)
  const websiteComponentsTranslations = getWebsiteComponentsTranslationsForLang(lang)

  // Cms translations last to allow overrides
  const allTranslations = { ...websiteComponentsTranslations, ...cmsTranslations }

  return (
    <IntlProvider locale={lang} defaultLocale={DEFAULT_LANG} messages={allTranslations}>
      {children}
    </IntlProvider>
  )
}
